export const colorTokens = {
  ink: "#0F0F0F",
  paper: "#FFFFFF",
  mist: "#F2F2F0",
  smoke: "#E4E4E0",
  ash: "#9B9B95",
  lime: "#32ffaa",
  limeLight: "#99ffce",
  limeDark: "#14a36e",
  ember: "#F97316",
  emberLight: "#FDBA74",
  emberDark: "#EA6C0A",
  sun: "#FFE54C",
  sunLight: "#FEF9C3",
  sunDark: "#D97706",
  positive: "#16A34A",
  warning: "#D97706",
  danger: "#DC2626",
  info: "#2563EB",
} as const;

export type ColorToken = keyof typeof colorTokens;

export const radiusTokens = {
  sm: "8px",
  md: "12px",
  lg: "20px",
  xl: "24px",
  full: "9999px",
} as const;

export const spacingTokens = {
  1: "4px",
  2: "8px",
  3: "12px",
  4: "16px",
  5: "20px",
  6: "24px",
  8: "32px",
  10: "40px",
  12: "48px",
  16: "64px",
} as const;

export const typography = {
  displayFamily: "'Be Vietnam Pro', system-ui, sans-serif",
  bodyFamily: "'Be Vietnam Pro', system-ui, sans-serif",
} as const;
